import { IBaseError } from "types";

export const getErrorMessages = (error: IBaseError): string[] => {
    const errorMessages: string[] = [];

    if (error.errors && Object.keys(error.errors).length > 0) {
        Object.entries(error.errors).forEach(([key, values]) => {
            const translationKey = `messages.${key}`;
            const messageKeys =
                translationKey !== `messages.${key}`
                    ? [translationKey]
                    : values;

            messageKeys.forEach((messageKey) => {
                errorMessages.push(`messages.${messageKey}`);
            });
        });
    } else {
        const messageTranslation = error.message;

        if (messageTranslation !== `messages.${error.message}`) {
            errorMessages.push(messageTranslation);
        } else {
            errorMessages.push("unexpected_fail");
        }
    }

    return errorMessages;
};
